(function () {
  const MAX_FILE_SIZE = 5 * 1024 * 1024;
  const ALLOWED_TYPES = ['image/jpeg', 'image/png', 'application/pdf'];
  const ALLOWED_EXTENSIONS = ['.jpg', '.jpeg', '.png', '.pdf'];

  function isAllowedFile(file) {
    if (!file) return false;
    const name = file.name.toLowerCase();
    const hasValidExtension = ALLOWED_EXTENSIONS.some((ext) => name.endsWith(ext));
    return ALLOWED_TYPES.includes(file.type) || hasValidExtension;
  }

  function formatFileSize(bytes) {
    if (bytes < 1024) return bytes + ' B';
    if (bytes < 1024 * 1024) return (bytes / 1024).toFixed(1) + ' KB';
    return (bytes / (1024 * 1024)).toFixed(1) + ' MB';
  }

  function initWarrantyForm(form) {
    const fileInput = form.querySelector('[data-warranty-file-input]');
    const fileTrigger = form.querySelector('[data-warranty-file-trigger]');
    const fileLabel = form.querySelector('[data-warranty-file-label]');
    const fileError = form.querySelector('[data-warranty-file-error]');
    const invoiceField = form.querySelector('[data-warranty-invoice-field]');
    const bodyField = form.querySelector('[data-warranty-body-field]');
    const submitButton = form.querySelector('[type="submit"]');

    if (!fileInput || !fileTrigger || !fileLabel) return;

    fileTrigger.addEventListener('click', function () {
      fileInput.click();
    });

    fileTrigger.addEventListener('keydown', function (event) {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        fileInput.click();
      }
    });

    fileInput.addEventListener('change', function () {
      const file = fileInput.files && fileInput.files[0];

      if (fileError) {
        fileError.hidden = true;
        fileError.textContent = '';
      }

      if (!file) {
        fileLabel.textContent = fileTrigger.dataset.defaultLabel || 'Choose file';
        fileTrigger.classList.remove('dashcam-warranty__file-trigger--has-file');
        if (invoiceField) invoiceField.value = '';
        return;
      }

      if (!isAllowedFile(file)) {
        fileInput.value = '';
        fileLabel.textContent = fileTrigger.dataset.defaultLabel || 'Choose file';
        fileTrigger.classList.remove('dashcam-warranty__file-trigger--has-file');
        if (invoiceField) invoiceField.value = '';
        if (fileError) {
          fileError.hidden = false;
          fileError.textContent = 'Please upload a JPG, PNG, or PDF file.';
        }
        return;
      }

      if (file.size > MAX_FILE_SIZE) {
        fileInput.value = '';
        fileLabel.textContent = fileTrigger.dataset.defaultLabel || 'Choose file';
        fileTrigger.classList.remove('dashcam-warranty__file-trigger--has-file');
        if (invoiceField) invoiceField.value = '';
        if (fileError) {
          fileError.hidden = false;
          fileError.textContent = 'File must be 5 MB or smaller.';
        }
        return;
      }

      fileLabel.textContent = file.name + ' (' + formatFileSize(file.size) + ')';
      fileTrigger.classList.add('dashcam-warranty__file-trigger--has-file');

      if (invoiceField) {
        invoiceField.value = file.name + ' (' + formatFileSize(file.size) + ')';
      }
    });

    form.addEventListener('submit', function () {
      const name = form.querySelector('[data-warranty-name]');
      const email = form.querySelector('[data-warranty-email]');
      const phone = form.querySelector('[data-warranty-phone]');
      const model = form.querySelector('[data-warranty-model]');
      const purchaseDate = form.querySelector('[data-warranty-purchase-date]');
      const invoiceNumber = form.querySelector('[data-warranty-invoice-number]');
      const file = fileInput.files && fileInput.files[0];

      const invoiceInfo = file
        ? file.name + ' (' + formatFileSize(file.size) + ') — customer selected; follow up if a copy is needed.'
        : 'Not provided';

      if (invoiceField) {
        invoiceField.value = invoiceInfo;
      }

      if (bodyField) {
        bodyField.value = [
          '--- Warranty Registration ---',
          '',
          'Customer Details',
          'Full Name: ' + (name ? name.value.trim() : ''),
          'Email: ' + (email ? email.value.trim() : ''),
          'Phone: ' + (phone ? phone.value.trim() : ''),
          '',
          'Product Details',
          'Product Model: ' + (model ? model.value.trim() : ''),
          'Purchase Date: ' + (purchaseDate ? purchaseDate.value : ''),
          'Invoice Number: ' + (invoiceNumber ? invoiceNumber.value.trim() : ''),
          'Invoice Upload: ' + invoiceInfo
        ].join('\n');
      }

      if (submitButton) {
        submitButton.disabled = true;
        submitButton.setAttribute('aria-busy', 'true');
      }
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    const form = document.getElementById('WarrantyRegistrationForm');
    if (form) initWarrantyForm(form);
  });
})();
